let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8A5UV")).then(() => parcelRequire('b3IO0'));